import { createApiSlice } from "@common/common-slice/commonSlice";

import {
  GET_USER_DETAILS,
} from "@routes";

// Define the API config array
const apiConfig = [
  {
    name: "getUserDetails",
    method: "get",
    url: GET_USER_DETAILS,
    stateKey: "userDetails",
  },
];

// Define custom reducers and their initial state
const customReducers = {
  initialState: {
    loading: false,
    isNewProject: false,
    message: "",
    errMessage: "",
    callProjectApi: "",
    approvalRecordsProject360: [],
    reviewRecordsProject360: [],
    publishRecordsProject360: [],
    approvalRecordsGRCNest: [],
    reviewRecordsGRCNest: [],
    publishRecordsGRCNest: [],
    reviewRecordsAllApplications: [],
    approveRecordsAllApplications: [],
    publishRecordsAllApplications: [],
    myProjectData: [],
    projectBacklog: [],
    selectedData: {},
    selectedOrganization: {},
    selectedUser: {},
    selectedTaskUser: "",
    selectedTaskPhase: null,
    selectedTaskTaskType: null,
    selectedTaskSearchTerm: "",
    selectedTaskSearchTermDelivered: "",
    selectedDepartment: "",
    selectedProject: {},
    selectedApplication: {},
    selectedAccount: {},
    selectedAccountforDashboard: {},
    selectedModule: {},
    backgroundColor: false,
    selectedOrganizationBackup: {},
    selectedAccountBackup: {},
    selectedProjectBackup: {},
    selectedUserBackup: {},
    selectedApplicationBackup: {},
    selectedModuleBackup: {},
    selectedBacklogRelease: {},
    selectedBacklogReleaseDelivered: null,
    selectedReleaseProduct: null,
    selectedReleaseModule: null,
    selectedPhase: {},
    selectedScope: {},
    selectedGoal: {},
    selectedGoalObjective: {},
    selectedTaskType: {},
    selectedBacklogUser: {},
    userDetails: {},
    selectedProduct: {},
    selectedProductModule: null,
    // Risk Framework Selction
    selectedRiskFramework: {},
    selectedRiskSection: {},
    selectedRiskDimension: {},
    selectedSystem: null,
    selectedSubSection: {},
    selectedInitiative: {},
    selectedProcess: {},
    isViewFramework: false,
    // Payload to get the org setup configs for dropdown
    rc360Payload: null,
    selectedPrototype: {},
    selectedBacklogPhaseRelease: {},
    // below two commented because when license is expired the error message is not displaying.
    showErrorAlert: false,
    showErrorAlertMessage: false,
    selectedFeatureUser: {},
    // This is for after switching to assessment preview page refreshing and navigating to the dashboard
    refreshed: true,
    fromWhichAssessment: "",
    // Landing Page
    getAssignedData: "assigned",
    // Project360 Landing Page state values for tabs
    project360LandingPageTabValue: 0,
    //  Use Case Kanban
    useCase: [],
    //  Use Case Kanban
    selectedUseCaseUser: null,
    selectedUseCaseRelease: null,
    selectedUseCasePhaseRelease: null,
    //  Feature Release Kanban
    featureReleaseData: [],
    selectedFeatureRelease: null,
    selectedProductFeatureRelease: null,
    selectedModuleFeatureRelease: null,
    selectedFeaturePhaseRelease: null,
    featureReleaseSearchTerm: "",
    selectedFeatureFunctionalityPhaseRelease: null,
    selectedFeatureFunctionalityRelease: null,
    selectedFeatureFunctionalityProductRelease: null,
    selectedFeatureFunctionalityModuleRelease: null,
    featureFunctionalityReleaseSearchTerm: "",
    selectedFeatureUseCasePhaseRelease: null,
    selectedFeatureUseCaseRelease: null,
    selectedFeatureUseCaseProductRelease: null,
    selectedFeatureUseCaseModuleRelease: null,
    featureUseCaseReleaseSearchTerm: "",
    // state values for displaying product, initiatives and framework
    isDisplayProduct: false,
    isDisplayInitiative: false,
    isDisplayFramework: false,
    isDisplayFrameworkBtn: false,
    officeData: null,
  },
  reducers: {
    setShowErrorAlert: (state, action) => {
      state.showErrorAlert = action?.payload;
    },
    setShowErrorAlertMessage: (state, action) => {
      state.showErrorAlertMessage = action?.payload;
    },


    applicationSelect: (state, action) => {
      state.selectedApplicationBackup = state.selectedApplication;
      state.selectedApplication = action?.payload;
    },
  },
};

const { slice, thunks, actions } = createApiSlice(
  "myProject",
  apiConfig,
  customReducers
);
const myProjectSlice = slice;

export default myProjectSlice.reducer;

export const {
  getUserDetails
} = thunks;

export const {
  setShowErrorAlert,
  setShowErrorAlertMessage,
} = actions;